




import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import { useEffect, useState } from "react"
import styled from "styled-components"
import InputText from "../../shared/input/new/InputText"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { showModal } from "../../../features/modal/modalSlice"
import PageTopTitle from "../../shared/PageTopTitle"
import Btn from "../../shared/button/Btn"
import SmallSpinner from "../../shared/spinners/SmallSpinner"
import InputDate from "../../shared/input/new/InputDate"

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 900px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .content{
            padding: 40px 0;
            width: 800px;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 20px;
        }

        .button-grp{
            width: 100%;
            display: flex;
            justify-content: center;
            margin-top: auto;
            margin: 30px 0;
            gap: 50px;
        }
    }
`

const AdminUyeTCDogrulaModal = () => {
    const dispatch = useDispatch()
    const location = useLocation()
    const { uyeItemData} = useSelector(state => state.admin2)

    const {modalLocation } = useSelector(state => state.modal)
    const { lockScroll, unlockScroll } = useScrollLock();
    const [userData, setUserData] = useState({
        adSoyad: uyeItemData.adSoyadUnvan,
        dogumTarihi: uyeItemData.dogumTarihi,
        tcNo: uyeItemData.tckn
    })

    const handleChange = ({e, type}) => {
        if(type === "number")
            setUserData((prev) => ({ ...prev, [e.target.name]: e.target.value }));

    }

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    const handleSubmit = () => {
     
    }
  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))}>
    <div className="modal" onClick={(e) => e.stopPropagation()}>
        <PageTopTitle title={"Üye TC Doğrula"}/>
        <div className="content">
            <InputText data={userData.adSoyad} setData={(e) => handleChange({type: "text", value: e})} labelText="Adı Soyadı" inputWidth={"280px"} name={"adSoyad"}/>
            <InputDate data={userData.dogumTarihi} setData={(e) => handleChange({type:"date", value: e})} labelText={"Doğum Tarihi"} inputWidth={"280px"} name={"dogumTarihi"}/>
            <InputText data={userData.tcNo} setData={(e) => handleChange({type: "number", e})} labelText={"TC No"} inputWidth={"280px"} name={"tcNo"}/>
        </div>

        <div className="button-grp">
            <Btn width={"240px"} bgColor="#E85446" color="#fff" handleClick={handleSubmit}>{false ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : "Doğrula"}</Btn>
            <Btn width={"240px"} bgColor="transparent" color="#E85446" handleClick={() => dispatch(showModal(null))}>Geri Dön</Btn>
        </div>
    </div>
</ModalContainer>
  )
}

export default AdminUyeTCDogrulaModal